import type { ReactNode } from 'react';
import { Icon } from '../components/Icon';

const KEYS: [string, string][] = [
  ['1', ''], ['2', 'ABC'], ['3', 'DEF'], ['4', 'GHI'], ['5', 'JKL'], ['6', 'MNO'], ['7', 'PQRS'], ['8', 'TUV'], ['9', 'WXYZ'],
];

/**
 * The number pad from the mockup. Sign-in screens use it instead of the phone's keyboard so the layout is the one
 * the owner designed; a hardware keyboard still works (the screens listen for key presses too). It sits at the
 * bottom of the screen's column and keeps clear of the home indicator.
 */
export function Keypad({ onDigit, onBack, top }: { onDigit: (d: string) => void; onBack: () => void; top?: ReactNode }) {
  const key = (d: string, sub: string) => (
    <button key={d} type="button" aria-label={d} onClick={() => onDigit(d)} className="zr-key">
      <span style={{ fontSize: 25, lineHeight: '26px', fontWeight: 400 }}>{d}</span>
      <span style={{ fontSize: 9, lineHeight: '10px', fontWeight: 700, letterSpacing: '0.16em', opacity: sub ? 1 : 0 }}>{sub || '.'}</span>
    </button>
  );
  return (
    <div className="zr-keypad" style={{ position: 'relative', flex: 'none', background: 'var(--kb)', padding: top ? '0 0 calc(var(--sab) + 12px)' : '6px 6px calc(var(--sab) + 6px)', zIndex: 5 }}>
      {top}
      <div style={{ padding: top ? '0 6px' : 0, display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 6 }}>
        {KEYS.map(([d, s]) => key(d, s))}
        <div style={{ height: 46 }} />
        <button type="button" aria-label="0" onClick={() => onDigit('0')} className="zr-key">
          <span style={{ fontSize: 25, lineHeight: '26px', fontWeight: 400 }}>0</span>
        </button>
        <button type="button" aria-label="Delete" onClick={onBack} className="zr-key zr-key--plain">
          <Icon name="backspace" size={26} sw={1.7} />
        </button>
      </div>
    </div>
  );
}
